import type { StatusIndicatorProps } from '@cloudscape-design/components/status-indicator';

/** Maps a VpnGatewayRecord.vpnStatus value to a StatusIndicator type + label. Shared by the
 *  enrollment table and the gateway detail. An absent status is a provisioned gateway with no VPN
 *  row yet (fleet-cert-console#39): "not enrolled". */
export function vpnStatusIndicator(status: string | undefined): { type: StatusIndicatorProps.Type; label: string } {
  switch (status) {
    case 'applied':
      return { type: 'success', label: 'applied' };
    case 'requested':
      return { type: 'pending', label: 'requested' };
    case 'provisioning':
      return { type: 'in-progress', label: 'provisioning' };
    case 'applying':
      return { type: 'in-progress', label: 'applying' };
    case 'failed':
      return { type: 'error', label: 'failed' };
    default:
      return { type: 'stopped', label: status ?? 'not enrolled' };
  }
}
